import { useContext } from "react";
import { AppContext } from "../App";
import { formatMoney } from "../Helpers";
import { MdArrowOutward, MdDirectionsBike } from "react-icons/md";

export default function One({ data, isResale }) {
  const appContext = useContext(AppContext);

  function view() {
    // Only trigger navigation if NOT a resale item
    if (isResale) return;

    appContext.navTo({
      item: "side-view",
      subItem: "motorcycle-options",
      extraItem: data.uuid,
    });
  }

  return (
    // If isResale is true, we add a 'disabled' class (to handle hover/cursor via CSS)
    // and set onClick to null
    <div 
      className={`entity-card ${isResale ? "entity-card-disabled" : ""}`} 
      onClick={isResale ? null : view}
    >
      <div className="entity-card-main">
        <div className="entity-card-title-row">
          <h6 className="entity-card-title">{data.model}</h6>
          <span className={`status-pill ${data.status === "available" ? "status-pill-success" : "status-pill-muted"}`}>
            {data.status || "available"}
          </span>
        </div>

        <div className="entity-card-subtext">
          <span>
            <MdDirectionsBike size={16} /> 
            {isResale ? "Returned for resale" : "Ready for sales listing"}
          </span>
          
          {isResale && data.regNumber && (
            <span className="ms-2 badge bg-light text-dark border">
               Reg: {data.regNumber}
            </span>
          )}

          {!isResale && (
            <strong>{formatMoney(data.price || 0)}</strong>
          )}
        </div>
      </div>

      {!isResale && (
        <div className="entity-card-end">
          <MdArrowOutward />
        </div>
      )}
    </div>
  );
}